import { render } from "./RulesPage.vue?vue&type=template&id=7d9276e9"
import script from "./RulesPage.vue?vue&type=script&lang=js"
export * from "./RulesPage.vue?vue&type=script&lang=js"

import "./RulesPage.vue?vue&type=style&index=0&id=7d9276e9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__